import { render, staticRenderFns } from "./historyMessage.vue?vue&type=template&id=8ba161c8&"
import script from "./historyMessage.vue?vue&type=script&lang=js&"
export * from "./historyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports